<template>
    <div v-if="visible">
        <v-dialog
            v-model="dialog"
            max-width="800"
            persistent
        >
            <v-tabs
                slider-color="grey"
                v-model="tab"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab ripple>Payload</v-tab>
                <v-tab ripple v-if="actions">Actions</v-tab>

                <!-- Payload -->
                <v-tab-item>
                    <v-card class="pt-2 pl-2 pr-2 caption">
                        <pre>{{ info }}</pre>
                        <v-divider class="mt-2"></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>

                <!-- Actions -->
                <v-tab-item
                    v-if="actions">
                    <v-card>
                        <v-container fluid>
                            <v-row>
                                <v-col md="3" class="py-0">
                                    <v-text-field
                                        type="number"
                                        v-model="amount"
                                        label="Amount"
                                        class="pb-0"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row v-if="response && response.status">
                                <v-col md="12" class="py-0">
                                    <v-alert
                                        type="success"
                                        text border="left"
                                        dismissible
                                        class="mb-2">
                                        Description: Refund has been successfully processed
                                    </v-alert>
                                </v-col>
                            </v-row>
                            <v-row v-else-if="response && !response.status" class="px-4">
                                <v-col md="12" class="">
                                    <v-alert type="error" text border="left" dismissible>
                                        Code: {{ response.err[0] }}<br>
                                        Description: Refund failed
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="((row.paymentType == 'DB' || row.paymentType == 'CP'))"
                                :disabled="!amount"
                                color="error"
                                @click="refund()"
                            >Refund</v-btn>
                            <!-- <v-btn
                                v-if="((info.paymentType == 'PA' || info.paymentType == 'CP'))"
                                :disabled="!amount"
                                color="error"
                                @click="reversal()">
                            Reversal</v-btn> -->
                            <v-btn color="primary" @click="closeDialog">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        visible: Boolean,
        state: Boolean,
        info: Object,
        row: Object,
        binData: Object,
        scheduleDates: Array
    },
    computed: {
        dialog() {
            return this.visible ? true : false;
        },
        actions(e) {
            if(this.row.paymentType == 'DB' ||
               this.row.paymentType == 'CP') {
                   if(this.row.status == 1) {
                        return true;
                   }
                   else {
                       return false;
                   }
               }
            else {
                return false;
            }
        },
    },
    beforeMount() {
        this.role = this.$store.getters.role;
    },
    watch: {
        dialog(n, o) {
            if(n) {
                this.amount = Number(this.row.amount).toFixed(2);
            }
        }
    },
    data() {
        return {
            tab: null,
            data: null,
            response: null,
            uri: this.state ? 'live' : 'test',
            amount: null,
            role: null
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close', false);
        },
        refund() {
            axios({
                method: 'post',
                url: 'refund-cybersource',
                data: { amount: this.amount,
                        id: this.row.id,
                        ref: this.row.merchantTransactionId,
                        merchantUuid: this.row.merchantUuid,
                        userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.response = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        reversal() {
            
        }
    }
}
</script>

<style>
    .json-key-title {
        display: inline-flex;
        width: 200px;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>